module.exports = {
    abort: {
        mailing: {
            all: 'Versand stoppen',
        },
    },
    submit: {
        address: {
            all: 'Adresse speichern',
        },
        trip: {
            all: 'Reise speichern',
        },
        activity: {
            all: 'Arbeiten speichern',
        },
        cooperation: {
            all: 'Kooperation speichern',
        },
        artFormAddress: {
            all: 'Adresse speichern',
        },
        products: {
            all: 'Produkte speichern',
            useSelection: 'Manuelle Auswahl übernehmen',
            useFiltered: 'Gefilterte Auswahl übernehmen',
        },
        prompts: {
            useSelection: 'Auswahl übernehmen',
        },
        report: {
            all: 'Bericht speichern',
            generate: 'Bericht generieren',
        },
        ninjaModule: {
            all: 'Auswahl übernehmen',
            useSelection: 'Manuelle Auswahl übernehmen',
            useFiltered: 'Gefilterte Auswahl übernehmen',
        },
    },
    assign: {
        language: {
            all: 'Sprache zuweisen',
        },
        layout: {
            all: 'Layout zuweisen',
        },
        mailingLists: {
            all: 'Mailing-Listen zuweisen',
        },
    },
    showAssign: {
        layout: {
            all: 'Layout zuweisen',
        },
    },
    assignTagsByFilter: {
        address: {
            all: 'Gefilterten Adressen Tags zuweisen',
        },
    },
    filter: {
        address: {
            all: 'Adressen filtern',
        },
    },
    selectAll: {
        component: {
            all: 'Alle Komponenten auswählen',
        },
    },
    deselectAll: {
        component: {
            all: 'Alle Komponenten abwählen',
        },
    },
    choose: {
      promptChooser: {
          ignore: 'Ignorieren',
          empty: 'Ohne Prompt',
      },
    },
    chooseAll: {
        all: {
            all: 'Alle wählen'
        },
        productPromptAssociation: {
            all: 'Alle Prompt-Entscheidungen treffen'
        }
    },
    open: {
        routes: {
            all: 'Route öffnen',
        },
    },
    openArticleUrl: {
        product: {
            all: 'Artikel-Link öffnen',
        },
    },
    edit: {
        routeContent: {
            all: 'Inhalte bearbeiten',
        },
        route: {
            asHome: 'Als Startseite',
        },
        routeOptions: {
            all: 'Bearbeiten',
        },
    },
    showEdit: {
        serviceUsers: {
            all: 'Benutzer verwalten',
        },
        validator: {
            all: 'Validator bearbeiten',
        },
        contact: {
            all: 'Kontakt bearbeiten',
        },
        address: {
            all: 'bearbeiten',
            client: 'Kunden bearbeiten',
            journalist: 'Journalisten bearbeiten',
            media: 'Medium bearbeiten',
            advisor: 'Betreuer bearbeiten',
            contact: 'Ansprechpartner bearbeiten',
            navToTrips: 'Zu den Reisen',
            navToCooperations: 'Zu den Kooperationen',
            details: 'Anschrift anzeigen',
        },
        artFormAddress: {
            all: 'bearbeiten',
            details: 'Anschrift anzeigen',
        },
        mailing: {
            all: 'Aussendung bearbeiten',
        },
        mailingUrl: {
            all: 'Empfänger anzeigen',
        },
        product: {
            all: 'Produkt anzeigen',
        },
        subProducts: {
            all: 'Produkte wählen',
        },
        order: {
            all: 'Bestellung anzeigen',
        },
        coupon: {
            all: 'Gutschein anzeigen',
        },
        user: {
            all: 'Benutzer anzeigen',
        },
        routes: {
            all: 'Route anzeigen',
        },
        members: {
            all: 'Mitglied bearbeiten',
        },
    },
    connectLayout: {
        route: {
            all: 'Layout zuweisen',
        },
    },
    duplicate: {
        route: {
            all: 'Route duplizieren',
        },
        layout: {
            all: 'Layout duplizieren',
        },
        section: {
            all: 'Sektion duplizieren',
        },
        component: {
            all: 'Komponente duplizieren',
        },
        routeComponent: {
            all: 'Komponente duplizieren',
        },
        templateAtom: {
            all: 'Atom duplizieren',
        },
        atom: {
            all: 'Atom duplizieren',
        },
        service: {
            all: 'Service duplizieren',
        },
        privilege: {
            all: 'Privileg duplizieren',
        },
        client: {
            all: 'Klient duplizieren',
        },
        database: {
            all: 'Datenbank duplizieren',
        },
        user: {
            all: 'Benutzer duplizieren',
        },
        serviceUser: {
            all: 'Service-Benutzer duplizieren',
        },
        scope: {
            all: 'Scope duplizieren',
        },
        scopeRole: {
            all: 'ScopeRolle duplizieren',
        },
        tagScope: {
            all: 'TagScope duplizieren',
        },
    },
    showDuplicate: {
        banner: {
            all: 'Banner duplizieren',
        },
        route: {
            all: 'Route duplizieren',
        },
        layout: {
            all: 'Layout duplizieren',
        },
        section: {
            all: 'Sektion duplizieren',
        },
        component: {
            all: 'Komponente duplizieren',
        },
        routeComponent: {
            all: 'Komponente duplizieren (Dialog)',
        },
        templateAtom: {
            all: 'Atom duplizieren',
        },
        atom: {
            all: 'Atom duplizieren',
        },
        service: {
            all: 'Service duplizieren',
        },
        privilege: {
            all: 'Privileg duplizieren',
        },
        client: {
            all: 'Klient duplizieren',
        },
        database: {
            all: 'Datenbank duplizieren',
        },
        user: {
            all: 'Benutzer duplizieren',
        },
        serviceUser: {
            all: 'Service-Benutzer duplizieren',
        },
        scope: {
            all: 'Scope duplizieren',
        },
        scopeRole: {
            all: 'ScopeRolle duplizieren',
        },
        tagScope: {
            all: 'TagScope duplizieren',
        },
        newsletter: {
            all: 'Newsletter duplizieren',
        },
        mailinglist: {
            all: 'MailingList duplizieren',
        },
        mailing: {
            all: 'Aussendung duplizieren',
        },
        product: {
            all: 'Produkt duplizieren',
        },
    },
    showDuplicateOptions: {
        route: {
            all: 'Route duplizieren',
        },
    },
    delete: {
        banner: {
            all: 'Banner löschen',
        },
        route: {
            all: 'Route löschen',
        },
        layout: {
            all: 'Layout löschen',
        },
        section: {
            all: 'Sektion löschen',
        },
        component: {
            all: 'Komponente löschen',
        },
        routeComponent: {
            all: 'Komponente löschen',
        },
        templateAtom: {
            all: 'Atom löschen',
        },
        atom: {
            all: 'Atom löschen',
        },
        service: {
            all: 'Service löschen',
        },
        assignedService: {
            all: 'Zuweisung löschen',
        },
        privilege: {
            all: 'Privileg löschen',
        },
        client: {
            all: 'Klient löschen',
        },
        database: {
            all: 'Datenbank löschen',
        },
        user: {
            all: 'Benutzer löschen',
        },
        serviceUser: {
            all: 'Service-Benutzer löschen',
        },
        scope: {
            all: 'Scope löschen',
        },
        scopeRole: {
            all: 'ScopeRolle löschen',
        },
        tagScope: {
            all: 'TagScope löschen',
        },
        validator: {
            all: 'Validator löschen',
        },
        newsletter: {
            all: 'Newsletter löschen',
        },
        mailinglist: {
            all: 'MailingList löschen',
        },
        mailing: {
            all: 'Aussendung löschen',
        },
        segmentData: {
            all: 'Segment-Kriterium löschen',
        },
        address: {
            all: 'Adresse löschen',
        },
        addresses: {
            all: 'Adressen löschen',
        },
        trip: {
            all: 'Reise löschen',
        },
        activity: {
            all: 'Arbeit löschen',
        },
        cooperation: {
            all: 'Kooperation löschen',
        },
        contact: {
            all: 'Kontakt löschen',
        },
        addressConnection: {
            all: 'Verbindung löschen',
        },
        artFormAddress: {
            all: 'Addresse löschen',
        },
        subscriber: {
            all: 'Empfänger löschen',
        },
        product: {
            all: 'Produkt löschen',
        },
        prompt: {
            all: 'Prompt löschen',
        },
        order: {
            all: 'Bestellung löschen',
        },
        coupon: {
            all: 'Gutschein löschen',
        },
        events: {
            all: 'Event löschen',
        },
        news: {
            all: 'News-Eintrag löschen',
        },
        customers: {
            all: 'Kunde löschen',
        },
        participants: {
            all: 'Teilnehmer löschen',
        },
        members: {
            all: 'Mitglied löschen',
        },
    },
    connectLanguage: {
        route: {
            all: 'Sprache zuweisen',
        },
    },
    showSelect: {
        address: {
            all: 'auswählen',
            client: 'Kunde auswählen',
            journalist: 'Journalist auswählen',
            media: 'Medium auswählen',
            advisor: 'Betreuer auswählen',
            contact: 'Ansprechpartner auswählen',
            nlMailingArtCrmAddressImport: 'Newsletter-Adressen via CRM'
        },
        products: {
            all: 'Produkte auswählen',
            empty: 'Produktauswahl leeren',
        },
        prompts: {
            all: 'Prompt auswählen',
            empty: 'Promptauswahl leeren',
        },
    },
    showSelectColumns: {
        participants: {
            all: 'Spalten wählen',
        },
    },
    insert: {
        tagScope: {
            root: 'TagScope hinzufügen',
            all: 'TagScope hinzufügen',
        },
    },
    showInsert: {
        route: {
            rootLang: 'Sprach-Route hinzufügen',
            root: 'Haupt-Route hinzufügen',
            before: 'Vor dieser Route',
            after: 'Nach dieser Route',
            within: 'Als Sub-Route',
        },
        section: {
            all: 'Sektion hinzufügen',
            before: 'Vor dieser Sektion',
            after: 'Nach dieser Sektion',
        },
        layout: {
            root: 'Layout hinzufügen',
            within: 'Sub-Layout hinzufügen',
        },
        component: {
            all: 'Komponente hinzufügen',
            group: 'Komponente hinzufügen',
            before: 'Vor dieser Komponente',
            after: 'Nach dieser Komponente',
            within: 'Als Unter-Komponente',
            root: 'Als Haupt-Komponente',
            bulkRoot: 'Haupt-Komponente hinzufügen',
        },
        routeComponent: {
            root: 'Neue Haupt-Komponente',
            before: 'Vor dieser Komponente',
            after: 'Nach dieser Komponente',
            within: 'Als Unter-Komponente',
        },
        atom: {
            all: 'Atom hinzufügen',
        },
        service: {
            all: 'Service hinzufügen',
        },
        assignedService: {
            all: 'Service zuweisen',
        },
        privilege: {
            all: 'Privileg hinzufügen',
        },
        client: {
            all: 'Klient hinzufügen',
        },
        banner: {
            all: 'Banner hinzufügen',
        },
        database: {
            all: 'Datenbank hinzufügen',
        },
        user: {
            all: 'Benutzer hinzufügen',
        },
        serviceUser: {
            all: 'Service-Benutzer hinzufügen',
        },
        scope: {
            all: 'Scope hinzufügen',
        },
        scopeRole: {
            all: 'ScopeRolle hinzufügen',
        },
        tagScope: {
            root: 'TagScope hinzufügen',
            all: 'TagScope hinzufügen',
        },
        validator: {
            all: 'Validator hinzufügen',
        },
        newsletter: {
            all: 'Newsletter hinzufügen',
        },
        mailinglist: {
            all: 'MailingList hinzufügen',
        },
        mailing: {
            all: 'Aussendung hinzufügen',
        },
        address: {
            all: 'Addresse anlegen',
        },
        contact: {
            all: 'Kontakt anlegen',
        },
        trip: {
            all: 'Reise anlegen',
        },
        activity: {
            all: 'Arbeit anlegen',
        },
        cooperation: {
            all: 'Kooperation anlegen',
        },
        addressConnection: {
            all: 'Verbindung herstellen',
        },
        subscriber: {
            all: 'Empfänger anlegen',
        },
        product: {
            all: 'Produkt anlegen',
        },
        productState: {
            all: 'Zeitraum hinzufügen',
        },
        productPrice: {
            all: 'Preis hinzufügen',
        },
        prompt: {
            all: 'Prompt anlegen',
        },
        order: {
            all: 'Bestellung anlegen',
        },
        coupon: {
            all: 'Gutschein anlegen',
        },
        events: {
            all: 'Event anlegen',
        },
        news: {
            all: 'News anlegen',
        },
        customers: {
            all: 'Kunde anlegen',
        },
        participants: {
            all: 'Teilnehmer anlegen',
        },
        members: {
            all: 'Mitglied anlegen',
        },
        jobs: {
            all: 'Job anlegen',
        },
    },
    reset: {
      routes: {
        all: 'Routenzuweisung löschen',
      },
    },
    refresh: {
        address: {
            all: 'Adressen neu laden',
            single: 'Adresse neu laden',
        },
        trip: {
            all: 'Reisen neu laden',
        },
        activity: {
            all: 'Arbeiten neu laden',
        },
        cooperation: {
            all: 'Kooperationen neu laden',
        },
        mailing: {
            all: 'Aussendungen neu laden',
        },
        mailingUrl: {
            all: 'Klicks neu laden',
        },
        product: {
            all: 'Produkte neu laden',
        },
        productAdditionalInformation: {
            all: 'KI-Texte neu laden',
        },
        productPromptAssociation: {
            all: 'Prompt-Entscheidungen neu laden',
        },
        prompt: {
            all: 'Prompts neu laden',
        },
        order: {
            all: 'Bestellungen neu laden',
        },
        coupon: {
            all: 'Gutscheine neu laden',
        },
        user: {
            all: 'Benutzer neu laden',
        },
        subscriber: {
            all: 'Empfänger neu laden',
        },
        protocol: {
            all: 'Protokoll neu laden',
            stats: {
                all: 'Statistik neu laden',
            },
        },
        news: {
            all: 'News neu laden',
        },
        events: {
            all: 'Events neu laden',
        },
        participants: {
            all: 'Teilnehmer neu laden',
        },
        members: {
            all: 'Mitglieder neu laden',
        },
        jobs: {
            all: 'Jobs neu laden',
        },
        customers: {
            all: 'Kunden neu laden',
        },
    },
    refreshData: {
        mailing: {
            all: 'Aussendungsdaten aktualisieren',
        },
        smsStats: {
            all: 'SMS-Statistik-Daten aktualisieren',
        },
        userSessions: {
            all: 'Session-Daten aktualisieren',
        },
    },
    export: {
        validator: {
            all:      'Exportieren',
            copy:     'Kopieren',
            csv:      'CSV',
            excel:    'Excel',
            pdf:      'PDF',
            print:    'Drucken',
        },
        address: {
            all: 'Exportieren',
            newsletter: 'Newsletter *',
            label: 'Etiketten',
            addresses: 'Adressen',
            artFormAddresses: 'Adressen',
            artFormLabels: 'Etiketten',
            artFormKubeos: 'Kubeos',
        },
        trip: {
            all: 'Exportieren',
        },
        activity: {
            all: 'Exportieren',
        },
        cooperation: {
            all: 'Exportieren',
        },
        subscriber: {
            all: 'Exportieren',
        },
        product: {
            all: 'Exportieren',
        },
        participants: {
            all: 'Exportieren',
        },
    },
    import: {
        subscriber: {
            setProperties: 'Eigenschaften setzen',
            removeProperties: 'Eigenschaften entfernen',
            create: 'Anlegen',
        },
        productAdditionalInformation: {
            all: 'Importieren',
        },
    },
    showImport: {
        routeComponent: {
            all: 'Aus Route importieren',
            article: 'Aus Produkt importieren',
        },
        subscriber: {
            all: 'Importieren',
        },
        component: {
            all: 'Import',
        },
        category: {
            all: 'Import',
        },
    },
    showPreview: {
        mailing: {
            all: 'Aussendung in neuem Fenster anzeigen',
        },
    },
    upload: {
        subscriberImporter: 'Empfänger hochladen',
        reportSourceUploader: 'Berichtdaten hochladen',
        productAdditionalInformationImporter: 'KI-Texte hochladen',
    },
    lazyload: {
        address: {
            all: 'Weitere Adressen laden',
        },
        contact: {
            all: 'Weitere Kontakte laden',
        },
        trip: {
            all: 'Weitere Reisen laden',
        },
        activity: {
            all: 'Weitere Arbeiten laden',
        },
        cooperation: {
            all: 'Weitere Kooperationen laden',
        },
        addressConnection: {
            all: 'Weitere Verbindungen laden',
        },
        mailing: {
            all: 'Weitere Aussendungen laden',
        },
        mailingUrl: {
            all: 'Weitere Klicks laden',
        },
        product: {
            all: 'Weitere Produkte laden',
        },
        productAdditionalInformation: {
            all: 'Weitere KI-Texte laden',
        },
        productPromptAssociation: {
            all: 'Weitere Prompt-Entscheidungen laden',
        },
        prompt: {
            all: 'Weitere Prompts laden',
        },
        order: {
            all: 'Weitere Bestellungen laden',
        },
        coupon: {
            all: 'Weitere Gutscheine laden',
        },
        user: {
            all: 'Weitere Benutzer laden',
        },
        subscriber: {
            all: 'Weitere Empfänger laden',
        },
        sectionComponents: {
            all: 'Weitere Komponenten laden',
        },
        protocol: {
            all: 'Weitere Protokoll-Einträge laden',
        },
        news: {
            all: 'Weitere News-Einträge laden',
        },
        events: {
            all: 'Weitere Events laden',
        },
        participants: {
            all: 'Weitere Teilnehmer laden',
        },
        smsStats: {
            all: 'Weitere Statistik-Einträge laden',
        },
        userSessions: {
            all: 'Weitere Session-Einträge laden',
        },
        members: {
            all: 'Weitere Mitglieder laden',
        },
        jobs: {
            all: 'Weitere Jobs laden',
        },
        customers: {
            all: 'Weitere Kunden laden',
        },
    },
    setProcessed: {
        address: {
            all: 'Als abgearbeitet markieren',
        },
    },
    showMove: {
        routeComponent: {
            all: 'In Route verschieben',
            article: 'In Produkt verschieben',
        },
        sectionComponent: {
            all: 'Komponente verschieben',
        },
    },
    move: {
        address: {
            down: 'Adresse nach unten verschieben',
            up: 'Adresse nach oben verschieben',
        },
        contact: {
            down: 'Kontakt nach unten verschieben',
            up: 'Kontakt nach oben verschieben',
        },
    },
    schedule: {
        mailing: {
            all: 'Versand starten',
        },
    },
    unschedule: {
        mailing: {
            all: 'Versand verhindern',
        },
    },
    moveToStart: {
        component: {
            all: 'An den Anfang verschieben',
        },
    },
    moveToBefore: {
        component: {
            all: 'Vor Auswahl verschieben',
        },
    },
    moveToAfter: {
        component: {
            all: 'Nach Auswahl verschieben',
        },
    },
    moveToEnd: {
        component: {
            all: 'An das Ende verschieben',
        },
    },
    showProtocol: {
        all: {
            all: 'Protokoll anzeigen',
        },
        route: {
            all: 'Protokoll anzeigen',
        },
        routeComponent: {
            all: 'Protokoll anzeigen',
            article: 'Protokoll anzeigen',
        },
        layout: {
            all: 'Protokoll anzeigen',
        },
        section: {
            all: 'Protokoll anzeigen',
        },
        sectionComponent: {
            all: 'Protokoll anzeigen',
        },
        product: {
            all: 'Protokoll anzeigen',
        },
    },
    addNinjaComponentInstance: {
        all: {
            all: 'Komponente anlegen',
        },
        evs_events: {
            all: 'Komponente anlegen',
        },
        evs_eventParts: {
            all: 'Komponente anlegen',
        },
        cms_news: {
            all: 'Komponente anlegen',
        },
        cms_newsParts: {
            all: 'Komponente anlegen',
        },
        cms_customers: {
            all: 'Komponente anlegen',
        },
        cms_customerParts: {
            all: 'Komponente anlegen',
        },
    },
    addNinjaRoute: {
        all: {
            all: 'Route anlegen',
        },
    },
    requestProductAdditionalInformation: {
        all: {
            all: 'KI-Texte generieren',
        },
        product: {
            all: 'KI-Texte generieren',
        },
        productAdditionalInformation: {
            all: 'KI-Texte generieren',
        },
    },
    requestProductsAdditionalInformation: {
        all: {
            all: 'KI-Texte generieren',
        },
        product: {
            all: 'KI-Texte generieren',
        },
        productAdditionalInformation: {
            all: 'KI-Texte generieren',
        },
    },
}
